<div *ngFor="let page of customPages" [innerHTML]="page.html | safeHtml"></div>
